export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'boltHome' */ 'components/bolt/home/home') },
	'contest': { id: 'contest', page: 'customScroll', getter: () => import(/* webpackChunkName: 'contest' */ 'components/bolt/customScroll/customScroll') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "boltSynopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis' },
	{ id: 'boltGallery', getter: () => import(/* webpackChunkName: "boltGallery" */ 'components/bolt/gallery/gallery'), component: 'gallery' }
];
import text from 'components/bolt/text/text';
import gallery from 'components/bolt/gallery/gallery';
export const sectionsWithParent = [
	{ id: 'contestBody', isPreloaded: true, component: text, parent: 'contest' },
	{ id: 'contestVideo', isPreloaded: true, component: gallery, parent: 'contest' },
	{ id: 'contestBody2', isPreloaded: true, component: text, parent: 'contest' },
	{ id: 'contestGallery', isPreloaded: true, component: gallery, parent: 'contest' },
	{ id: 'contestLegal', isPreloaded: true, component: text, parent: 'contest' }
];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
